import {useI18n} from '@logistics-frontend/core/i18n'
import {Point} from '@yandex-taxi/js-integration-api'
import {useRoute} from '@yandex-taxi/react-integration-api'
import {useMapContext, useMapEvent, useMapUtil} from '@yandex-taxi/react-ymaps'
import {useCallback} from 'react'

import {CenterAndZoom} from 'src/shared/types'
import {isEqualCenterAndZoom} from 'src/shared/utils'

import {useMaxRoutePoints} from './hooks'
import {useMapAddress as useAddress, useSetBoundsSettings} from './map-bounds'
import {useNotificationCallback} from './notifications'
import {TabName} from './types'
import {canAddAddress, parseValidAddresses} from './utils'

const MAX_ADDRESSES_ADDED_ERROR = 'Добавлено макс. количество адресов'

type Props = {
  tab: string
  bounds?: Point[]
}

const MapEvents: React.FC<Props> = ({tab, bounds}) => {
  const t = useI18n()
  const [{value: route = []}] = useRoute()
  const firstEmptyAddress = route.findIndex(point => !point.address)
  const [, {setValue}] = useAddress(firstEmptyAddress >= 0 ? firstEmptyAddress : route.length)
  const setBoundsSettings = useSetBoundsSettings()
  const util = useMapUtil()
  const map = useMapContext()
  const addNotification = useNotificationCallback()
  const maxRoutePoints = useMaxRoutePoints()

  useMapEvent(
    'click',
    useCallback(
      e => {
        if (tab !== TabName.DRAFT) {
          return
        }
        if (canAddAddress(maxRoutePoints, parseValidAddresses(route))) {
          setValue(e.get('coords'))
          return
        }
        const removeNotification = addNotification({
          message: t('order.history.address.max_added_error', MAX_ADDRESSES_ADDED_ERROR),
          severity: 'warning',
        })
        setTimeout(() => removeNotification(), 3000)
      },
      [tab, maxRoutePoints, route, setValue, addNotification, t],
    ),
  )
  useMapEvent(
    'boundschange',
    useCallback(
      ({originalEvent}) => {
        const newCenterAndZoom: CenterAndZoom = {
          center: originalEvent.newCenter,
          zoom: originalEvent.newZoom,
        }
        if (
          isEqualCenterAndZoom(util, map.container.getSize(), bounds, newCenterAndZoom, map.margin._margin) ||
          !bounds
        ) {
          return
        }
        setBoundsSettings({shouldBounds: false})
      },
      [setBoundsSettings, util, map, bounds],
    ),
  )

  return null
}

export default MapEvents
